import Common from "../common/Common";

class Header1 {
  constructor() {
    this.common = new Common();
    if (document.querySelector(".l-header")) {
      this.header = document.querySelector(".l-header");
      this.mediaQueryList = this.common.matchMedia("md");
      this.menuButton = document.querySelector('.js-headerMenuButton');
      this.menuFlg = true;
      this.nav = document.querySelector(".l-header__menu");
      this.nav1Buttons = document.querySelectorAll('.js-headerNav1Button');
      //this.nav1Flg = true;
      //this.subNav = document.querySelector(".p-nav1__list2");
      //this.menu = this.button.nextElementSibling;
      this.searchButton = document.querySelector('.js-headerSearchButton');
      this.searchFlg = true;
      this.focusableElementsSelector =
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
      this.initialize();
    }
  }

  initialize() {
    this.mediaQueryList.addEventListener("change", this.resize.bind(this));
    this.fixed();
    this.fixedClose();

    if(document.querySelector('.js-headerMenuButton')) {
      this.resize();
      this.toggleMenu();
      this.toggleNav1();
      this.toggleSearch();
    }

    //if (this.mediaQueryList.matches) {
    //} else {
    //}
  }

  // ウィンドウサイズ変更時の処理
  resize() {
    if (this.mediaQueryList.matches) {
      // SPサイズになった時の処理
      this.menuButton.setAttribute("aria-expanded", "false");
      this.menuButton.hidden = false;
      this.menuFlg = true;
      this.menuButton.setAttribute("aria-label", "メニューを開く");
    } else {
      // PCサイズになった時の処理
      this.menuButton.removeAttribute("aria-expanded");
      this.menuButton.hidden = true;
      this.menuFlg = true;
      this.menuButton.setAttribute("aria-label", "メニューを開く");
    }
  }

  // メニューの開閉処理
  toggleMenu() {
    this.menuButton.addEventListener("click", (e) => {
      const expanded = e.currentTarget.getAttribute("aria-expanded") === "true";
      e.currentTarget.setAttribute("aria-expanded", String(!expanded));

      if (this.flg) {
        // 表示する
        this.flg = false;
        e.currentTarget.setAttribute("aria-label", "メニューを閉じる");
      } else {
        // 非表示にする
        this.flg = true;
        e.currentTarget.setAttribute("aria-label", "メニューを開く");
      }
    });

    // フォーカストラップ
    this.nav.addEventListener("keydown", (event) => {
      if (!this.menuFlg) {
        if (event.key === "Tab") {
          event.preventDefault();
          const focusableElements = Array.from(this.nav.querySelectorAll(this.focusableElementsSelector));
          const focusedItemIndex = focusableElements.indexOf(document.activeElement);
          if (event.shiftKey) {
            if (focusedItemIndex === 0) {
              // 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
              focusableElements[focusableElements.length - 1].focus();
            } else {
              // 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
              focusableElements[focusedItemIndex - 1].focus();
            }
          } else {
            if (focusedItemIndex === focusableElements.length - 1) {
              // 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
              focusableElements[0].focus();
            } else {
              // 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
              focusableElements[focusedItemIndex + 1].focus();
            }
          }
        }
      }
    });

    window.addEventListener("keydown", (e) => {
      //escキーでメニューを閉じる
      if (e.key === "Escape" && !this.flg) {
        this.menuButton.setAttribute("aria-expanded", "false");
        this.menuButton.focus();
        this.menuFlg = true;
        this.menuButton.setAttribute("aria-label", "メニューを開く");
      }
    });

    // ページ内遷移した時の処理
    let menuLink = this.nav.querySelectorAll('a');

    menuLink.forEach((link) => {
      link.addEventListener('click', (e) => {
        let linkUrl = link.getAttribute('href');
        if( linkUrl.includes('#') ) {
          const url = location.pathname;
          linkUrl = linkUrl.replace(/#.*$/, '');
          if( url === linkUrl ) {
            this.menuButton.setAttribute("aria-expanded", "false");
            this.menuButton.focus();
            this.menuFlg = true;
            this.menuButton.setAttribute("aria-label", "メニューを開く");
          }
        }
      });
    });
  }

  // 子メニューの開閉処理
  toggleNav1() {
    this.nav1Buttons.forEach(( button , i ) => {
      button.addEventListener("click", (e) => {
        if (this.mediaQueryList.matches) {
          e.preventDefault();
          if( button.classList.contains('is-active') ){
            button.classList.remove('is-active');
          } else {
            button.classList.add('is-active');
          }
        }
      });
    });
  }

  // 検索の開閉処理
  toggleSearch() {
    this.searchButton.addEventListener("click", (e) => {
      const expanded = e.currentTarget.getAttribute("aria-expanded") === "true";
      e.currentTarget.setAttribute("aria-expanded", String(!expanded));

      if (this.searchFlg) {
        // 表示する
        this.searchFlg = false;
        e.currentTarget.setAttribute("aria-label", "検索を閉じる");
      } else {
        // 非表示にする
        this.searchFlg = true;
        e.currentTarget.setAttribute("aria-label", "検索を開く");
      }
    });

    // フォーカストラップ
    this.nav.addEventListener("keydown", (event) => {
      if (!this.searchFlg) {
        if (event.key === "Tab") {
          event.preventDefault();
          const focusableElements = Array.from(this.nav.querySelectorAll(this.focusableElementsSelector));
          const focusedItemIndex = focusableElements.indexOf(document.activeElement);
          if (event.shiftKey) {
            if (focusedItemIndex === 0) {
              // 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
              focusableElements[focusableElements.length - 1].focus();
            } else {
              // 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
              focusableElements[focusedItemIndex - 1].focus();
            }
          } else {
            if (focusedItemIndex === focusableElements.length - 1) {
              // 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
              focusableElements[0].focus();
            } else {
              // 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
              focusableElements[focusedItemIndex + 1].focus();
            }
          }
        }
      }
    });

    window.addEventListener("keydown", (e) => {
      //escキーでメニューを閉じる
      if (e.key === "Escape" && !this.flg) {
        this.searchButton.setAttribute("aria-expanded", "false");
        this.searchButton.focus();
        this.searchFlg = true;
        this.searchButton.setAttribute("aria-label", "検索を開く");
      }
    });
  }

  // sticky時の処理
  fixed() {
    let scrollPos = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentPos = window.scrollY;
      if (currentPos < scrollPos) {
        this.header.classList.remove('is-hidden');
      } else {
        if (currentPos > 0) {
          this.header.classList.add('is-hidden');
        }
      }
      scrollPos = currentPos;
    });
  }

  // sticky時にページ内遷移した時の処理
  fixedClose() {
    let menuLink = this.nav.querySelectorAll('a');

    menuLink.forEach((link) => {
      link.addEventListener('click', (e) => {
        let linkUrl = link.getAttribute('href');
        if( linkUrl.includes('#') ) {
          const url = location.pathname;
          linkUrl = linkUrl.replace(/#.*$/, '');
          setTimeout(() => {
            if( url === linkUrl ) {
              this.header.classList.add('is-hidden');
            }
          }, 0);
        }
      });
    });
  }
}

export default Header1;
